<template>
  <v-container fluid class="deposit-list mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" md="8" class="d-flex flex-start justify-md-start">
              <v-btn color="success" class="button-shadow mr-2" @click="isFindDeposit=true">
                <v-icon class="mr-0">mdi-file-search</v-icon>
                Find
              </v-btn>
              <v-btn to="/invoice/list" color="default" class="button-shadow mr-2">
                <v-icon class="mr-0">mdi-file-multiple</v-icon>
                Invoices
              </v-btn>
              <v-btn to="/salesorder/list" color="default" class="button-shadow mr-2">
                <v-icon class="mr-0">mdi-file-multiple</v-icon>
                Orders
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="ma-1">
          <v-card-text>
            <v-data-table
              show-select
              item-key="_id"
              v-model="data_select"
              loading-text="Loading... Please wait"
              class="deposits-table"
              :loading="isReceiving || isDeleting"
              :footer-props="footer"
              :headers="header_deposit"
              :items="data_deposits"
              :items-per-page="itemPerPage">
              <template v-slot:top>
                <v-dialog
                  v-model="isDeleteDeposit"
                  width="500"
                >
                  <v-card>
                    <v-card-title>
                      Delete this Deposit?
                    </v-card-title>

                    <v-card-text>
                      {{ delete_deposit.depositnum }}
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" outlined @click="isDeleteDeposit = false">Cancel</v-btn>
                      <v-btn color="secondary" class="button-shadow" @click="deleteDeposit(delete_deposit)">Delete</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
              <template v-slot:item.userid="{ item }">
                <div v-if="item.userid!=undefined">
                <v-avatar v-if="users.length>0 && users.find(user=>user._id == item.userid)['userimage']!==''" size="40">
                  <img v-bind:src="users.find(user=>user._id == item.userid)['userimage']" alt="">
                </v-avatar>
                <v-avatar
                  v-else
                  color="warning"
                  size="40">
                  <span class="white--text headline">{{ users.length>0 ? users.find(user=>user._id == item.userid)['username'][0].toUpperCase() : '' }}</span>
                </v-avatar>
                <span style="margin-left:15px">{{ users.length>0 ? users.find(user=>user._id == item.userid)['username'] : '' }} </span>
                </div>
              </template>
              <template v-slot:item.depositnum="{ item }">
                <p class="two-line">{{ item.deposittype  }} {{ item.depositnum  }}</p>
                <p v-if="item.depositdate!=undefined" class="two-line">{{ new Date(item.depositdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' })  }}</p>
              </template>
              <template v-slot:item.accountid="{ item }">
                {{ accounts.length>0 && accounts.find(account=>account._id == item.accountid)!=null ? accounts.find(account=>account._id == item.accountid)['accountcode'] : '' }}
              </template>
              <template v-slot:item.locationid="{ item }">
                <p class="two-line">{{ locations.length>0 && locations.find(location=>location._id == item.locationid)!=null ? locations.find(location=>location._id == item.locationid)['locationname'] : '' }}</p>
                <p class="two-line">Ref: {{ item.refnum }}</p>
              </template>

              <template v-slot:item.transactions="{ item }">
                <p class="two-line" style="font-size: 10pt;">{{ getTransType(item) }}</p>
                <p class="two-line" style="font-size: 10pt;">{{ item.transactions.map(item=>item.transnum.toString()).join(', ') }}</p>
              </template>
              <template v-slot:item.deposittotal="{ item }">
                <p class="two-line">{{ item.deposittotal.toLocaleString('en-SG') }} {{primaryCurrency}}</p>
                <p v-if="isDualCurrency==true" class="two-line">{{ (item.deposittotal * currencyRate).toFixed(0) }} {{secondaryCurrency}}</p>
              </template>
              <template v-slot:item.depositstatus="{ item }">
                <v-chip
                  v-if="item.depositstatus!=undefined" :color="getStatusColor(item.depositstatus)"
                  small>
                  {{ item.depositstatus }}
                </v-chip>
              </template>
              <template v-slot:item.createdAt="{ item }">
                {{ new Date(item.createdAt).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
              </template>
              <template v-slot:item.actions="{ item }">
                <div v-if="item._id!=null">
                  <v-btn v-if="item.depositstatus!='Completed'" icon color="primary" @click="updateDepositConfirmDialog(item)">
                    <v-icon>mdi-text-box-edit</v-icon>
                  </v-btn>
                  <v-btn icon color="primary" @click="editItem(item)">
                    <v-icon>mdi-pencil-outline</v-icon>
                  </v-btn>
                  <v-btn v-if="item.depositstatus=='New'" icon color="primary" @click="deleteDepositDialog(item)">
                    <v-icon>mdi-delete-outline</v-icon>
                  </v-btn>
                  <v-btn icon color="primary" @click="printItem(item)">
                    <v-icon>mdi-printer</v-icon>
                  </v-btn>
                </div>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row justify="center">
    <v-dialog
      v-model="isFindDeposit"
      persistent
      max-width="600px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Find Deposits</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" md="6">
                <v-select
                  dense
                  :items="locations.filter(x=>x.locationstatus=='Active').map(x => {
                            return {text: x.locationname, value: x._id};
                          })"
                  v-model="find_query.locationid"
                  label="Location"
                  required
                ></v-select>
              </v-col>
              <v-col cols="12" md="6">
                <v-select
                  dense
                  :items="data_accounts"
                  v-model="find_query.accountid"
                  label="Account"
                  required
                ></v-select>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                        <v-menu
                          ref="menu_startdate"
                          v-model="menu_startdate"
                          :close-on-content-click="false"
                          :return-value.sync="find_query.startdate"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              dense
                              v-model="find_query.startdate"
                              label="Start Date"
                              v-bind="attrs"
                              v-bind:value="find_query.startdate"
                              v-on="on"
                              persistent-hint
                              single-line hint="Please enter start date">
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="find_query.startdate"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="menu_startdate = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.menu_startdate.save(find_query.startdate)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                        <v-menu
                          ref="menu_enddate"
                          v-model="menu_enddate"
                          :close-on-content-click="false"
                          :return-value.sync="find_query.enddate"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              dense
                              v-model="find_query.enddate"
                              label="End Date"
                              v-bind="attrs"
                              v-bind:value="find_query.enddate"
                              v-on="on"
                              persistent-hint
                              single-line hint="Please enter end date">
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="find_query.enddate"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="menu_enddate = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.menu_enddate.save(find_query.enddate)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="isFindDeposit = false"
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="resetDeposits"
          >
            Reset
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="findBatchDeposits"
          >
            Find
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="isConfirmSend"
        persistent
        width="400px"
        max-width="800px"
      >
          <v-card>
            <v-card-title>
              <span class="text-h5">Confirm Deposit</span>
            </v-card-title>
            <v-card-text>
              {{ confirm_send.deposittype }} {{ confirm_send.depositnum }}
            </v-card-text>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" md="12">
                    <v-text-field
                      v-model="confirm_send.confirm"
                      required
                      dense
                      persistent-hint
                      single-line hint="Type the word 'Confirm'"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="isConfirmSend=false; confirm_send={}"
              >
                Close
              </v-btn>
              <v-btn
                color="blue darken-1"
                text
                :disabled="confirm_send.confirm!=='Confirm'"
                @click="updateDepositConfirm"
              >
                Confirm
              </v-btn>
            </v-card-actions>
          </v-card>
      </v-dialog>
  </v-row>
  </v-container>
</template>

<script>
import config from "../../../config"
import { mapState, mapActions } from 'vuex'
import { getStatusColor } from "../../../util/tools";

export default {
  name: 'DepositList',
  data() {
    return {
      config,
      isFindDeposit: false,
      isDeleteDeposit: false,
      isConfirmSend: false,
      menu_startdate: null,
      menu_enddate: null,
      itemPerPage: 500,
      isDualCurrency: false,
      primaryCurrency: null,
      secondaryCurrency: null,
      currencyRate: null,
      find_query: {},
      confirm_send: {},
      delete_deposit: {},
      footer: {'items-per-page-options': [500, 1000, 5000]},
      header_deposit: [
        { text: 'Deposit', value: 'depositnum', sortable: false, width: '10%' },
        { text: 'Invoice & Order Num', value: 'transactions' },
        { text: 'Location', value: 'locationid', width: '15%' },
        { text: 'Account', value: 'accountid', width: '15%' },
        { text: 'Amount', value: 'deposittotal', width: '10%' },
        { text: 'Status', value: 'depositstatus', width: '10%' },
        { text: 'Actions', value: 'actions', sortable: false, width: '10%' },
      ],
      data_deposits: [],
      data_select: [],
      getStatusColor: getStatusColor,
    }
  },
  computed: {
    ...mapState('Account', ['accounts']),
    ...mapState('BatchDeposit', ['batchdeposits', 'query', 'isReceiving', 'isDeleting', 'depositsMessage', 'isUpdating']),
    ...mapState('Location', ['locations']),
    ...mapState('SystemSetting', ['settings']),
    ...mapState('User', ['users']),
    ...mapState('Vendor', ['vendors']),
    data_accounts(){
      let result = this.accounts.filter(account=>account.accountsubclass=='Bank');
      let filter = this.accounts.filter(account=>account.accountname.includes('Advance') || account.accountname.includes('Prepayment'));
      let results = [...result, ...filter];
      return results.map(x => { return {text: x.accountname, value: x._id} });
    },
  },
  methods: {
    ...mapActions('Account', ["getAccountsRequest"]),
    ...mapActions('BatchDeposit', ["getBatchDepositsRequest", "findBatchDepositsRequest", "deleteBatchDepositRequest", "updateBatchDepositConfirmRequest"]),
    ...mapActions('Location', ["getLocationsRequest"]),
    ...mapActions('SystemSetting', ["getSetting", "getSystemSettingsRequest"]),
    ...mapActions('User', ["getUsersRequest"]),

    editItem(item) {
      this.$router.push({ name: 'BatchDepositEdit', params: item });
    },
    printItem(item) {
      this.$router.push({ name: 'BatchDepositPrint', params: item });
    },
    getTransType(item){
      if(item.transactions.length>0){
        if(item.transactions[0]['transtype'].includes('Invoice')) return 'Invoice';
        if(item.transactions[0]['transtype'].includes('Order')) return 'Order';
      }
      return '';
    },
    deleteDepositDialog(item) {
      this.isDeleteDeposit = true;
      this.delete_deposit = {_id: item._id, depositnum: item.depositnum}
    },
    async deleteDeposit(item) {
      this.isDeleteDeposit = false;
      await this.deleteBatchDepositRequest(item);
      this.data_deposits = Object.assign([], this.batchdeposits);
    },
    async findBatchDeposits(){
      this.isFindDeposit = false;
      if(this.find_query=={}){
        await this.getBatchDepositsRequest();
        this.data_deposits = Object.assign([], this.batchdeposits);
        for(var i in this.data_deposits){
          let deposit = this.data_deposits[i];
          deposit.ordernums = deposit.transactions.map(item=>item.transnum.toString()).join(', ');
        }
      }
      else{
        let result = await this.findBatchDepositsRequest(this.find_query);
        this.data_deposits = Object.assign([], result);
        for(var j in this.data_deposits){
          let deposit = this.data_deposits[j];
          deposit.ordernums = deposit.transactions.map(item=>item.transnum.toString()).join(', ');
        }
      }
    },
    async resetDeposits(){
      this.find_query = {};
    },
    updateDepositConfirmDialog(item) {
      this.isConfirmSend = true;
      this.confirm_send = { _id: item._id, depositnum: item.depositnum, deposittype: item.deposittype };
    },
    async updateDepositConfirm() {
      this.isConfirmSend = false;
      console.log('1')
      console.log(this.confirm_send);
      let result = await this.updateBatchDepositConfirmRequest(this.confirm_send);
      let index = this.data_deposits.findIndex((x) => x._id == result._id);
      this.data_deposits.splice(index, 1, result);
      this.confirm_send = {};
    },
  },
  async created () {
    if(Object.keys(this.query).length==0){
      if(this.batchdeposits.length==0) await this.getBatchDepositsRequest();
      this.data_deposits = Object.assign([], this.batchdeposits);
    }
    else {
      this.find_query = Object.assign({}, this.query)
      let result = await this.findBatchDepositsRequest(this.query);
      this.data_deposits = Object.assign([], result);
    }
    
    for(var i in this.data_deposits){
      let deposit = this.data_deposits[i];
      deposit.ordernums = deposit.transactions.map(item=>`${item.transnum}`).join(', ');
    }

    if(this.accounts.length==0) await this.getAccountsRequest();
    if(this.locations.length==0) await this.getLocationsRequest();
    if(this.users.length==0) await this.getUsersRequest();

    this.primaryCurrency = await this.getSetting({code: 'CurrencySettings', name: 'PrimaryCurrency'}, );
    this.secondaryCurrency = await this.getSetting({code: 'CurrencySettings', name: 'SecondaryCurrency'}, );
    this.currencyRate = await this.getSetting({code: 'CurrencySettings', name: 'DefaultCurrencyRate'}, );
    this.isDualCurrency = this.primaryCurrency!=null && this.secondaryCurrency!=null ? (this.primaryCurrency!=this.secondaryCurrency) : false;
  },
}
</script>

<style src="./List.scss" lang="scss"></style>
